<dx-popup
    #arPaymentDetailBox
    *ngIf="!!arPaymentDetail"
    width="50%"
    height="40%"
    [title]="popUpTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="ar-payment-detail-content">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item baseSize="0" class="buttons-content">
                <dx-button
                    *ngIf="!!arPaymentDetail?.attachments?.length"
                    class="attachment-button"
                    type="default"
                    stylingMode="text"
                    [icon]="attachmentsIcon"
                    [text]="
                        arPaymentDetail?.attachments?.length > 1 ? '(' + arPaymentDetail?.attachments?.length + ')' : ''
                    "
                    (onClick)="showAttachmentList()"
                ></dx-button>
                <dx-button
                    *ngIf="isInternalUser"
                    class="history-button"
                    type="default"
                    stylingMode="text"
                    hint="Transaction History"
                    [icon]="historyIcon"
                    (onClick)="showTransactionHistory()"
                ></dx-button>
            </dxi-item>
            <dxi-item [ratio]="1">
                <dx-form
                    width="100%"
                    height="100%"
                    [colCount]="2"
                    [labelLocation]="defaultLabelLocation"
                    [formData]="arPaymentDetail"
                >
                    <dxi-item dataField="customerName">
                        <dxo-label text="Customer Name"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                mode="hyperlinkOnly"
                                [displayText]="arPaymentDetail?.customerName"
                                (onLinkClick)="navigateToProperty()"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="customerCode">
                        <dxo-label text="Account ID"></dxo-label>
                        <div *dxTemplate>
                            {{ arPaymentDetail?.customerCode }}
                        </div>
                    </dxi-item>
                    <dxi-item dataField="referenceNumber">
                        <dxo-label text="Document Number"></dxo-label>
                        <div *dxTemplate>
                            <div *ngIf="!!arPaymentDetail?.checkImagesDownloadUrl">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="arPaymentDetail?.referenceNumber"
                                    (onLinkClick)="downloadPaymentCheckImage()"
                                ></app-hyperlink-creator>
                            </div>
                            <span *ngIf="!arPaymentDetail?.checkImagesDownloadUrl">
                                {{ arPaymentDetail?.referenceNumber }}
                            </span>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="paymenType">
                        <dxo-label text="Payment Type"></dxo-label>
                        <div *dxTemplate>
                            <div *ngIf="!!arPaymentDetail?.checkImagesDownloadUrl">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="arPaymentDetail?.paymenType"
                                    (onLinkClick)="downloadPaymentCheckImage()"
                                ></app-hyperlink-creator>
                            </div>
                            <span *ngIf="!arPaymentDetail?.checkImagesDownloadUrl">
                                {{ arPaymentDetail?.paymenType }}
                            </span>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="docDate">
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            {{ arPaymentDetail?.docDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item dataField="postDate">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            {{ arPaymentDetail?.postDate | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item dataField="amount">
                        <dxo-label text="Payment"></dxo-label>
                        <div *dxTemplate>
                            <span>{{ currencyFormatter(arPaymentDetail?.amount) }} (</span>
                            <i>Remaining Transferable Amount:</i>
                            <app-hyperlink-creator
                                [displayText]="currencyFormatter(arPaymentDetail?.remainingTransferableAmount) + ')'"
                                (onLinkClick)="showPaymentTransferHistory()"
                            ></app-hyperlink-creator>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="appliedAmount">
                        <dxo-label text="Applied Amount"></dxo-label>
                        <div *dxTemplate>
                            <span *ngIf="arPaymentDetail.appliedAmount === 0">
                                {{ currencyFormatter(arPaymentDetail?.appliedAmount) }}
                            </span>
                            <div *ngIf="arPaymentDetail.appliedAmount > 0">
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="currencyFormatter(arPaymentDetail?.appliedAmount)"
                                    (onLinkClick)="showARCreditApplication()"
                                ></app-hyperlink-creator>
                            </div>
                            <div *ngIf="arPaymentDetail.unappliedAmount > 0">
                                <span>( Unapplied Amount:</span>
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    [displayText]="currencyFormatter(arPaymentDetail?.unappliedAmount) + ')'"
                                    (onLinkClick)="showARManualCreditApplication()"
                                ></app-hyperlink-creator>
                            </div>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="description">
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            {{ arPaymentDetail?.description }}
                        </div>
                    </dxi-item>
                    <dxi-item dataField="lastUpdate">
                        <dxo-label text="Last Updated By"></dxo-label>
                        <div *dxTemplate>
                            <app-user-bio-link
                                [user]="arPaymentDetail?.lastUpdate"
                                [communityId]="arPaymentParam?.communityId"
                            ></app-user-bio-link>
                            on {{ arPaymentDetail?.lastUpdate?.updatedTime | date: dateFormat }}
                        </div>
                    </dxi-item>
                    <dxi-item dataField="supportingDocument">
                        <dxo-label text="Supporting Document"></dxo-label>
                        <div *dxTemplate>
                            <app-hyperlink-creator
                                *ngIf="!!arPaymentDetail.supportingDocument.downloadUrl"
                                mode="hyperlinkOnly"
                                textLocation="right"
                                [displayText]="arPaymentDetail?.supportingDocument?.fileName"
                                (onLinkClick)="downloadSupportingDocument(arPaymentDetail.supportingDocument)"
                            >
                                <i
                                    class="fa-1x margin-right-3px"
                                    [ngClass]="getFileIconByExtension(arPaymentDetail?.supportingDocument)"
                                ></i>
                            </app-hyperlink-creator>
                            <span *ngIf="!arPaymentDetail.supportingDocument.downloadUrl">N/A</span>
                        </div>
                    </dxi-item>
                    <dxi-item dataField="subLedgerTitle">
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            {{ arPaymentDetail?.subLedgerTitle }}
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2" *ngIf="!!arPaymentDetail.reversedTransactionNumber">
                        <div *dxTemplate>
                            <p class="cc-text-required">
                                Note: This transaction has been reversed (Reversal transaction
                                {{ arPaymentDetail?.reversedTransactionNumber }})
                            </p>
                        </div>
                    </dxi-item>
                </dx-form>
            </dxi-item>
            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Close"
                                [icon]="closeIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="arPaymentDetail?.allowReverse">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                template="reverseBtnTemplate"
                                text="Reverse"
                                hint="Reverse"
                                (onClick)="onReverseClick()"
                            >
                                <div *dxTemplate="let btn of 'reverseBtnTemplate'">
                                    <span>
                                        <i [ngClass]="iconReverse"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="POST"
                                            apiUrl="api/cb/ar/payment/reverse"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="arPaymentDetail?.allowTransfer">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Transfer"
                                hint="Transfer"
                                template="transferBtnTemplate"
                                (onClick)="onTransferClick()"
                            >
                                <div *dxTemplate="let btn of 'transferBtnTemplate'">
                                    <span>
                                        <i [ngClass]="iconExchange"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="PUT"
                                            apiUrl="api/cb/ar/payment/transfer"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="arPaymentDetail?.allowDelete">
                        <div *dxTemplate>
                            <dx-button
                                type="danger"
                                template="deleteBtnTemplate"
                                text="Delete"
                                hint="Delete"
                                (onClick)="onDeleteClick()"
                            >
                                <div *dxTemplate="let btn of 'deleteBtnTemplate'" class="cc-button-template">
                                    <span>
                                        <i [class]="deleteIcon"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="SHIELD"
                                            apiAction="DELETE"
                                            apiUrl="api/cb/ar/payment"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="arPaymentDetail?.allowEdit">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Edit"
                                hint="Edit"
                                template="editBtnTemplate"
                                (onClick)="onEditClick()"
                            >
                                <div *dxTemplate="let btn of 'editBtnTemplate'">
                                    <span>
                                        <i [ngClass]="editIcon"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="PUT"
                                            apiUrl="api/cb/ar/payment"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="arPaymentDetail?.allowRefund">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                template="issueBtnTemplate"
                                text="Issue Refund"
                                hint="Issue Refund"
                                (onClick)="onIssueRefundClick()"
                            >
                                <div *dxTemplate="let btn of 'issueBtnTemplate'" class="cc-button-template">
                                    <span>
                                        <i class="fas fa-money-bill-wave"></i>
                                        {{ btn.text }}
                                        <app-security-info
                                            iconColor="cc-white-icon"
                                            securityIndicator="KEY"
                                            apiAction="PUT"
                                            apiUrl="api/cb/ar/payment/refund"
                                        ></app-security-info>
                                    </span>
                                </div>
                            </dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-ar-payment-transfer-history
    *ngIf="showTransferHistory"
    [visible]="showTransferHistory"
    [arPaymentParam]="arPaymentParam"
    (onTransferHistoryClose)="showTransferHistory = false"
></app-ar-payment-transfer-history>

<app-transaction-attachments
    *ngIf="showAttachments"
    [visible]="showAttachments"
    [attachmentData]="arPaymentDetail?.attachments"
    (onAttachmentsClose)="showAttachments = false"
></app-transaction-attachments>

<app-ar-payment-reverse-editor
    *ngIf="showReverseEditor"
    [visible]="showReverseEditor"
    [arPaymentParam]="arPaymentParam"
    [arPaymentDetail]="arPaymentDetail"
    (onReverseEditorClose)="showReverseEditor = false"
></app-ar-payment-reverse-editor>

<app-ar-payment-editor
    *ngIf="showPaymentEditor"
    [visible]="showPaymentEditor"
    [arPaymentParam]="arPaymentParam"
    [documentNo]="arPaymentDetail.referenceNumber"
    [customerId]="arPaymentDetail.customerCode"
    (onPaymentEditorClose)="showPaymentEditor = false"
    (onPaymentEditorClose)="onARPaymentEditorClose($event)"
></app-ar-payment-editor>

<app-ar-payment-transfer-editor
    *ngIf="showPaymentTransferEditor"
    [visible]="showPaymentTransferEditor"
    [arPaymentParam]="arPaymentParam"
    [documentNo]="arPaymentDetail?.referenceNumber"
    (onTransferPaymentEditorClose)="onPaymentTransferEditorClose($event)"
></app-ar-payment-transfer-editor>

<app-issue-refund-payment-editor
    *ngIf="showIssueRefundEditor"
    [visible]="showIssueRefundEditor"
    [arPaymentParam]="arPaymentParam"
    (onIssueRefundEditorClose)="onIssueRefundPaymentEditorClose($event)"
></app-issue-refund-payment-editor>

<app-transaction-history
    *ngIf="displayTransactionLogPopUp"
    [title]="transactionLogTitle"
    [transactionLogResultData]="transactionLogResultData"
    [communityId]="communityId"
    (onTransactionLogClose)="displayTransactionLogPopUp = false"
></app-transaction-history>

<app-ar-credit-application
    *ngIf="showCreditApplication"
    [visible]="showCreditApplication"
    [creditApplicationData]="creditApplicationData"
    [transactionType]="transactionType"
    [transactionId]="arPaymentDetail.paymentId"
    [communityId]="arPaymentDetail.communityId"
    [managementCompanyId]="arPaymentDetail.managementCompanyId"
    (onCreditApplicationClose)="closeCreditApplication($event)"
></app-ar-credit-application>

<app-ar-manual-credit-application
    *ngIf="showManualCreditApplication"
    [visible]="showManualCreditApplication"
    [transactionType]="transactionType"
    [transactionId]="arPaymentParam.paymentId"
    [communityId]="arPaymentDetail.communityId"
    [managementCompanyId]="arPaymentDetail.managementCompanyId"
    (onManualCAEditorClose)="onManualCAEditorClose($event)"
></app-ar-manual-credit-application>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#arPaymentDetailBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
